import ModalMedication from "./ModalMedication";

export default ModalMedication;